import {ListItem} from 'src/design-system';
import {Text} from 'react-native';
import React from 'react';
import {Typography} from 'src/styles';
import {compose} from 'recompose';
import {withObservables} from '@nozbe/watermelondb/react';
import {useStyle} from 'src/providers/style';

const PromptListItem = ({
  prompt,
  drag,
  canEdit,
  editCallback,
  canDelete,
  deleteCallback,
  isActive,
}: any) => {
  const styles = useStyle();

  const toggleCallback = (selectedPrompt: any) => {
    if (selectedPrompt?.enabled) {
      selectedPrompt.updateEntity({
        enabled: false,
      });
    } else {
      selectedPrompt.updateEntity({
        enabled: true,
      });
    }
  };

  const text =
    prompt?.name +
    ' ' +
    (prompt?.acronym !== '' ? '(' + prompt?.acronym + ')' : '');
  return (
    <ListItem
      content={
        <Text style={[Typography.P3_MEDIUM, styles.textColorPrimary]}>
          {text}
        </Text>
      }
      enabled={prompt?.enabled}
      toggle={() => toggleCallback(prompt)}
      drag={drag}
      isActive={isActive}
      canEdit={canEdit}
      editCallback={editCallback}
      canDelete={canDelete}
      deleteCallback={deleteCallback}
    />
  );
};

export default compose(
  withObservables(['prompt'], ({prompt}: any) => ({
    prompt,
  })),
)(PromptListItem);
